import { render, staticRenderFns } from "./AddEditCase.vue?vue&type=template&id=cb45c224&scoped=true"
import script from "./AddEditCase.vue?vue&type=script&lang=js"
export * from "./AddEditCase.vue?vue&type=script&lang=js"
import style0 from "./AddEditCase.vue?vue&type=style&index=0&id=cb45c224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45c224",
  null
  
)

export default component.exports